import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import { initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyBza66tX1eoUbEzvGzM2Wl0j8yTuaMECdc",
  authDomain: "aao-nxt.firebaseapp.com",
  databaseURL: "https://aao-nxt.firebaseio.com",
  projectId: "aao-nxt",
  storageBucket: "aao-nxt.appspot.com",
  messagingSenderId: "637371577064",
  appId: "1:637371577064:web:baa3113a697d6f253ecf5d",
  measurementId: "G-RGSMF6ZRDD"
};

export const firebaseApp = initializeApp(firebaseConfig);

export const fbLogEvent = (event_name, event_body, localStorage) => {
  const analytics = getAnalytics(firebaseApp);
  const ls = JSON.parse(localStorage.getItem('u'));
  const userId = ls && '_id' in ls ? ls._id : 'GUEST_USER';

  logEvent(analytics, event_name, {
    ...event_body,
    user_id: userId,
  });
  setUserId(analytics, userId)
}
